import CrudRequest from '@rootCommon/services/crud-request';
import { ORGANIZATION_SECURITY_SETTING } from '@rootCommon/constants/end-points';
import { OrganizationSecuritySetting, OrganizationSecuritySettingDto } from '@rootCommon/types/orgSecuritySetting';

class SecuritySettingService extends CrudRequest<OrganizationSecuritySetting, OrganizationSecuritySettingDto> {
  constructor() {
    super(ORGANIZATION_SECURITY_SETTING);
  }

  getByOrgId = async (organizationId: number): Promise<OrganizationSecuritySetting> => {
    const res = await CrudRequest.get<OrganizationSecuritySetting>(ORGANIZATION_SECURITY_SETTING, {
      params: { organizationId },
    });

    return res.data;
  };
}

export default new SecuritySettingService();
